export default __webpack_public_path__ + "static/media/baner-top_zylki_2027.9ff85b8d.jpg";